module.exports = __webpack_public_path__ + "static/img/project_banner2.48e3495.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_banner2.png
// module id = m1bx
// module chunks = 1